import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';

import EventStreamPlayer from '../EventStreamPlayer';
import Partners from '../Partners';
import EpisodeDescription from './Description';
import { TITVEpisodeProps } from './interfaces';

const queryClient = new QueryClient();

const TITVEpisode = ({
  initialCurrentUser,
  isGdprRequired,
  isWebview,
  env,
  latestEpisode,
  mostRecentStream,
  nextEpisode,
  partnerAds,
  signupNewsletter,
}: TITVEpisodeProps) => {
  const { Track } = useEventTracking({
    page: Page.TITVEvent,
    contentId: mostRecentStream?.guid,
  });

  return (
    <Track>
      <AppContextProvider
        initialCurrentUser={initialCurrentUser}
        isGdprRequired={isGdprRequired}
        isWebview={isWebview}
        env={env}
      >
        <QueryClientProvider client={queryClient}>
          <EventStreamPlayer
            latestEpisode={latestEpisode}
            mostRecentStream={mostRecentStream}
            nextEpisode={nextEpisode}
          />
          <div className="mt-40 px-28">
            <div className="m-auto max-w-container-lg">
              <EpisodeDescription event={mostRecentStream} signupNewsletter={signupNewsletter} />
              {partnerAds?.length > 0 && <Partners partnerAds={partnerAds} hasBorder />}
            </div>
          </div>
        </QueryClientProvider>
      </AppContextProvider>
    </Track>
  );
};

export default TITVEpisode;
